module.exports = __webpack_public_path__ + "img/complementary.3f5ea027.jpg";